(function () {
    'use strict';

    angular.module('cimerFrontEndApp').directive('reportPlotScatter', [function () {

        var _parseData = function(inputData) {
            var outData = {
                points: [],
                xRange: [],
                yRange: []
            };
            var tempPoint = {};
            var x = 0;
            //outData.xRange.push(inputData.questionCount + '.' + 0); //pad beginning with Q.0
            outData.yRange.push(0);
            for (var i = 0; i < inputData.Questions.length; i++) {
                tempPoint = {
                    x: (inputData.questionCount + '.' + inputData.Questions[i].promptCount),
                    y: inputData.Questions[i].Mean,
                    s: inputData.Questions[i].StandardDeviation
                };
                outData.points.push(tempPoint);
                outData.xRange.push(tempPoint.x);
                x = inputData.Questions[i].promptCount > x ? inputData.Questions[i].promptCount : x;
            }
            x++;
            //outData.xRange.push(inputData.questionCount + '.' + x); //pad end with Q.(x+1)
            //also grab full scale length
            if (outData.points.length > 0) {
                for (var q = 0; q < inputData.Questions[0].QuestionScale.length; q++) {
                    outData.yRange.push(inputData.Questions[0].QuestionScale[q].AnswerNumber);
                }
            }

            return outData;
        };


        return {
            restrict: 'A',
            scope: {
                inputData: '=reportPlotScatter'
            },
            link: function (scope, element, attrs) {
                 
                /* -------- Setup Display Configuration -------- */
                var VizWidth = element[0].offsetWidth;
                var VizHeight = element[0].offsetHeight;

                var margin = { top: 20, right: 20, bottom: 30, left: 40 },
                    width = VizWidth - margin.left - margin.right,
                    height = VizHeight - margin.top - margin.bottom,
                    size = 5,
                    color = 'red',
                    printWidth = 700,
                    printHeight = 250;

                //build svg element and print element
                var svg = d3.select(element[0]).append("svg")
                    .attr("viewBox", "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))
                    .attr("data-w", width)
                    .attr("data-h", height) 
                    .attr("class","hidden-print")
                  .append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                var svgPrint = d3.select(element[0]).append("svg")
                    .attr("viewBox", "0 0 " + printWidth + " " + printHeight)
                    .attr("data-w", printWidth - margin.left - margin.right)
                    .attr("data-h", printHeight - margin.top - margin.bottom)
                    .attr("class","visible-print-block")
                  .append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                // render plot when data has been injected
                scope.$watch('inputData', function (newVals, oldVals) {
                    if (newVals) {  //don't send if null
                        renderGraph(_parseData(angular.copy(newVals)), svg);
                        renderGraph(_parseData(angular.copy(newVals)), svgPrint);
                        return
                    }
                }, true);

                /* -------- Graph Render Function -------- */
                function renderGraph(data, svgEl) {

                    //console.log(data);
                    //get width and height from data attribute
                    var svgWidth = svgEl.node().ownerSVGElement.getAttribute("data-w");
                    var svgHeight = svgEl.node().ownerSVGElement.getAttribute("data-h");
                    //clear all previous items
                    svgEl.selectAll('*').remove();
                    //return if no data
                    if (data.points.length < 1)
                        { return; }

                    var x = d3.scale.ordinal()
                        .domain(data.xRange)
                        .rangeRoundPoints([0, svgWidth],0.2);
                    var y = d3.scale.linear()
                        .domain(d3.extent(data.yRange))
                        .range([svgHeight, 0]);

                    var xAxis = d3.svg.axis()
                        .scale(x)
                        .orient("bottom");
                    var yAxis = d3.svg.axis()
                        .scale(y)
                        .tickValues(data.yRange)
                        .orient("left");

                    //get data
                    var d = svgEl.selectAll("g")
                            .data(data.points),
                        dEnter = d.enter()
                            .append("g");
                            

                    //add dots
                    dEnter.append("svg:circle")
                        .attr("class", "dot")
                        .attr("r", size)
                        .attr("cx", function (d) { return x(d.x); })
                        .attr("cy", function (d) { return y(d.y); })
                        .attr("fill", color);
                    //add error bars
                    dEnter.append("svg:line")
                        .attr("class", "error-bar")
                        .attr("x1", function (d) { return x(d.x); })
                        .attr("y1", function (d) { return y(d.y - d.s); })
                        .attr("x2", function (d) { return x(d.x); })
                        .attr("y2", function (d) { return y(d.y + d.s); })
                        .style("stroke", color)
                        .style("stroke-width", size/2);

                    //finally draw axes
                    svgEl.append("g")
                        .attr("class", "x axis")
                        .attr("transform", "translate(0," + svgHeight + ")")
                        .call(xAxis);

                    svgEl.append("g")
                        .attr("class", "y axis")
                        .call(yAxis);



                }

            } //end link
        }; //end return
    }]);

    angular.module('cimerFrontEndApp').directive('reportPlotBar', [function () {

        var _parseData = function (inputData) {
            var outData = {
                points: [],
                yRange: [],
                maxCount: null
            };

            var textLength = 0,
                count = 0,
                tempPoint = {};

            for (var i = 0; i < inputData.QuestionScale.length; i++) {
                tempPoint = {
                    x: inputData.QuestionScale[i].Count,
                    y: inputData.QuestionScale[i].AnswerNumber+':'+inputData.QuestionScale[i].AnswerTextPlainText
                };
                if (inputData.QuestionScale[i].Count > count) { count = inputData.QuestionScale[i].Count; }
                outData.yRange.push(tempPoint.y);
                outData.points.push(tempPoint);
            }

            outData.maxCount = count;

            return outData;
        };

        return {
            restrict: 'A',
            scope: {
                inputData: '=reportPlotBar'
            },
            link: function (scope, element, attrs) {

                angular.element(document).ready(function () {
                    /* -------- Setup Display Configuration -------- */
                    var VizWidth = element[0].offsetWidth;
                    var VizHeight = element[0].offsetHeight;

                    var margin = { top: 20, right: 20, bottom: 30, left: 200 },
                        width = VizWidth - margin.left - margin.right,
                        height = VizHeight - margin.top - margin.bottom,
                        color = 'red',
                        barPadding = 0.2,
                        barPaddingOuter = 0.1,
                        printWidth = 700,
                        printHeight = 250;

                    //build svg and print elements
                    var svg = d3.select(element[0]).append("svg")
                        .attr("viewBox", "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))
                        .attr("data-w", width)
                        .attr("data-h", height)
                        .attr("class", "hidden-print")
                      .append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                    var svgPrint = d3.select(element[0]).append("svg")
                        .attr("viewBox", "0 0 " + printWidth + " " + printHeight)
                        .attr("data-w", printWidth - margin.left - margin.right)
                        .attr("data-h", printHeight - margin.top - margin.bottom)
                        .attr("class", "visible-print-block")
                      .append("g")
                        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                    // render plot when data has been injected
                    scope.$watch('inputData', function (newVals, oldVals) {
                        if (newVals) {  //don't send if null
                            renderGraph(_parseData(angular.copy(newVals)), svg);
                            renderGraph(_parseData(angular.copy(newVals)), svgPrint);
                            return
                        }
                    }, true);

                    /* -------- Graph Render Function -------- */
                    function renderGraph(data, svgEl) {

                        //get width and height from data attribute
                        var svgWidth = svgEl.node().ownerSVGElement.getAttribute("data-w");
                        var svgHeight = svgEl.node().ownerSVGElement.getAttribute("data-h");

                        //return if no data
                        if (data.points.length < 1) { return; }
                        //clear all previous items
                        svgEl.selectAll('*').remove();

                        var x = d3.scale.linear()
                            .domain([0, data.maxCount])
                            .range([0, svgWidth]);
                        var y = d3.scale.ordinal()
                            .domain(data.yRange)
                            .rangeRoundBands([0, svgHeight], barPadding, barPaddingOuter);

                        var xAxis = d3.svg.axis()
                            .scale(x)
                            .ticks(data.maxCount)
                            .outerTickSize(0)
                            .orient("bottom");
                        var yAxis = d3.svg.axis()
                            .scale(y)
                            .outerTickSize(0)
                            .orient("left");

                        //get data
                        var d = svgEl.selectAll("g")
                                .data(data.points),
                            dEnter = d.enter()
                                .append("g");

                        //add bars
                        dEnter.append("svg:rect")
                            .attr("class", "plot-bar")
                            .attr("height", y.rangeBand())
                            .attr("x", 0)
                            .attr("y", function (d) { return y(d.y); })
                            .attr("width", function (d) { return x(d.x); })
                            .attr("fill", color);

                        //finally draw axes
                        svgEl.append("g")
                            .attr("class", "x axis")
                            .attr("transform", "translate(0," + svgHeight + ")")
                            .call(xAxis);

                        svgEl.append("g")
                            .attr("class", "y axis")
                            .call(yAxis);

                    }
                });

            } //end link

        }; //end return

    }]);

}());